import { ForwardedRef, forwardRef, ReactNode } from "react";
import styled from "styled-components";
import {
  typography,
  TypographyProps,
  color,
  ColorProps,
  space,
  SpaceProps,
} from "styled-system";

interface TableHeadProps extends TypographyProps, ColorProps, SpaceProps {
  /**
   * children elements
   */
  children: ReactNode;
  /**
   *The element's unique identifier
   */
  id?: string;
  /**
   * automatically set, please don't use it
   */
  sticky?: boolean;
}

const Head = styled.thead<TableHeadProps>`
  box-sizing: border-box;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;

  ${(props) =>
    props.sticky
      ? ` position: sticky;
  top: 0;`
      : ""}
  z-index: 1;
  ${typography}
  ${color}
  ${space}
`;

const TableHead = forwardRef(
  (
    {
      children,
      id,
      fontSize = "h6",
      fontWeight = "medium",
      color = "table-head-font-color",
      backgroundColor = "table-head-bg-color",
      sticky = false,
      padding = 6,
      ...props
    }: TableHeadProps,
    ref: ForwardedRef<HTMLTableSectionElement>
  ) => {
    return (
      <Head
        id={id}
        ref={ref}
        fontSize={fontSize}
        fontWeight={fontWeight}
        color={color as string}
        backgroundColor={backgroundColor}
        sticky={sticky}
        padding={padding}
        {...props}
      >
        {children}
      </Head>
    );
  }
);

export default TableHead;
